import React, { useEffect, useState } from "react";
import { Label } from "../../ui/Label";
import { Input } from "../../ui/Input";
import { Textarea } from "../../ui/Textarea";

const CampaignForm = ({ parentFormData = {}, onChangeValues, type }) => {
  const [formData, setFormData] = useState({
    lead_name: "",
    campaign_name: "",
    left_navigation: "",
    page_header_text: "",
    video_title: "",
    video_link: "",
    button_one_text: "",
    button_one_link: "",
    button_two_text: "",
    button_two_link: "",
    button_three_text: "",
    button_three_link: "",
    bot_script: ""
  });

  useEffect(() => {
    setFormData(parentFormData);
    return () => setFormData(formData);
  }, [parentFormData, formData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    onChangeValues({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="rounded-lg shadow-sm max-w-4xl mx-auto">
        <div className="space-y-6">
          {type === "lead" && (
            <div className="flex max-md:flex justify-center">
              <img
                src={formData.file_url}
                alt="Profile"
                className="h-24 w-24 rounded-full object-cover border-4 border-indigo-100"
              />
            </div>
          )}

          <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
            {type === "lead" ? (
              <div>
                <Label className={"block"} htmlFor={"lead_name"}>
                  Lead Name
                </Label>
                <Input
                  name="lead_name"
                  id="lead_name"
                  className={"pl-12 px-4"}
                  placeholder="Enter lead name"
                  type="text"
                  value={formData.lead_name || ""}
                  onChange={handleChange}
                />
              </div>
            ) : (
              <div>
                <Label className={"block"} htmlFor={"campaign_name"}>
                  Campaign Name
                </Label>
                <Input
                  name="campaign_name"
                  id="campaign_name"
                  className={"pl-12 px-4"}
                  placeholder="Enter campaign name"
                  type="text"
                  value={formData.campaign_name || ""}
                  onChange={handleChange}
                />
              </div>
            )}

            <div>
              <Label className={"block"} htmlFor={"left_navigation"}>
                Left Navigation Subtitle
              </Label>
              <Input
                name="left_navigation"
                id="left_navigation"
                className={"pl-12 px-4"}
                placeholder="Enter navigation subtitle"
                type="text"
                value={formData.left_navigation || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1">
            <Label className={"block"} htmlFor={"page_header_text"}>
              Page Header Text
            </Label>
            <Input
              name="page_header_text"
              id="page_header_text"
              className={"pl-12 px-4"}
              placeholder="Enter page header text"
              type="text"
              value={formData.page_header_text || ""}
              onChange={handleChange}
            />
          </div>

          <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
            <div>
              <Label className={"block"} htmlFor={"video_title"}>
                Video Title
              </Label>
              <Input
                name="video_title"
                id="video_title"
                className={"pl-12 px-4"}
                placeholder="Enter video title"
                type="text"
                value={formData.video_title || ""}
                onChange={handleChange}
              />
            </div>
            <div>
              <Label className={"block"} htmlFor={"video_link"}>
                Video Link
              </Label>
              <Input
                name="video_link"
                id="video_link"
                className={"pl-12 px-4"}
                placeholder="Enter video link"
                type="text"
                value={formData.video_link || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
            <div>
              <Label className={"block"} htmlFor={"button_one_text"}>
                Button One Text
              </Label>
              <Input
                name="button_one_text"
                id="button_one_text"
                className={"pl-12 px-4"}
                placeholder="Enter first button text"
                type="text"
                value={formData.button_one_text || ""}
                onChange={handleChange}
              />
            </div>
            <div>
              <Label className={"block"} htmlFor={"button_one_link"}>
                Button One Link
              </Label>
              <Input
                name="button_one_link"
                id="button_one_link"
                className={"pl-12 px-4"}
                placeholder="Enter one button link"
                type="text"
                value={formData.button_one_link || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
            <div>
              <Label className={"block"} htmlFor={"button_two_text"}>
                Button Two Text
              </Label>
              <Input
                name="button_two_text"
                id="button_two_text"
                className={"pl-12 px-4"}
                placeholder="Enter second button text"
                type="text"
                value={formData.button_two_text || ""}
                onChange={handleChange}
              />
            </div>
            <div>
              <Label className={"block"} htmlFor={"button_two_link"}>
                Button Two Link
              </Label>
              <Input
                name="button_two_link"
                id="button_two_link"
                className={"pl-12 px-4"}
                placeholder="Enter second button link"
                type="text"
                value={formData.button_two_link || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
            <div>
              <Label className={"block"} htmlFor={"button_three_text"}>
                Button Three Text
              </Label>
              <Input
                name="button_three_text"
                id="button_three_text"
                className={"pl-12 px-4"}
                placeholder="Enter button three text"
                type="text"
                value={formData.button_three_text || ""}
                onChange={handleChange}
              />
            </div>
            <div>
              <Label className={"block"} htmlFor={"button_three_link"}>
                Button Three Link
              </Label>
              <Input
                name="button_three_link"
                id="button_three_link"
                className={"pl-12 px-4"}
                placeholder="Enter button three link"
                type="text"
                value={formData.button_three_link || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1">
            <div>
              <Label className={"block"} htmlFor={"bot_script"}>
                Bot Script
              </Label>
              <Textarea
                id="bot_script"
                rows={4}
                placeholder="Write your script here..."
                value={formData.bot_script || ""}
                name="bot_script"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignForm;
